let settings = {
  path: 'settings',
  name: 'settings',
  redirect: '/settings/list',
  component: () => import('@/views/settings/index.vue'),
  children: [
    {
      path: '/paySetting',
      name: 'paySettingIndex',
      component: () => import('@/views/settings/pages/paySetting.vue'),
      meta: {
        name: '支付设置'
      }
    },
    {
      path: '/basicInfo',
      name: 'basicInfoIndex',
      component: () => import('@/views/settings/pages/basicInfo.vue'),
      meta: {
        name: '基本信息'
      }
    },
    // 新增 子账号 角色相关内容
    {
      path: '/subAccount',
      name: 'subAccountList',
      component: () => import('@/views/settings/pages/subAccount/list.vue'),
      meta: {
        name: '子账号管理'
      }
    },
    {
      path: '/subAccount/detail/:accoutId',
      name: 'subAccountDetail',
      component: () => import('@/views/settings/pages/subAccount/detail.vue'),
      meta: {
        name: '子账号详情'
      }
    },
    {
      path: '/subAccount/createSubAccount',
      name: 'createSubAccount',
      component: () => import('@/views/settings/pages/subAccount/createAccount.vue'),
      meta: {
        name: '新建子账号'
      }
    },
    {
      path: '/subAccount/createRole',
      name: 'createRole',
      component: () => import('@/views/settings/pages/subAccount/createRole.vue'),
      meta: {
        name: '新建角色'
      }
    }
  ]
}

export default settings
